import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CommonModule } from '@angular/common';

import { Comparable } from '../../../../helpers/entities/comparable.interface';
import { Trackable } from '../../../../helpers/entities/trackable.interface';
import { DetailListLayoutComponent } from '../../../../layouts/detail-list-layout/detail-list-layout.component';
import { ShGenericOverviewContainerComponent } from '../../../generic-overview/containers/generic-overview/generic-overview.container.component';

import { ShSearchBarContainerComponent } from '../../../../advanced-search/filters/containers/search-bar/search-bar.container.component';
import { ShIconBadgeComponent } from '../../../../elements/components/icon-badge/icon-badge.component';
import { SearchPageSandbox } from '../../search-page.sandbox';
import { SearchPageContainerComponent } from '../search-page/search-page.container.component';
@Component({
    standalone: true,
    selector: 'sh-embedded-search-page',
    templateUrl: './embedded-search-page.container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [SearchPageSandbox],
    imports: [
        CommonModule,
        ShGenericOverviewContainerComponent,
        DetailListLayoutComponent,
        ShIconBadgeComponent,
        ShSearchBarContainerComponent
    ]
})
export class EmbeddedSearchPageContainerComponent<
    T extends Comparable & Trackable
> extends SearchPageContainerComponent<T> {}
